<template>
  <div class="space-y-3">
    <div v-for="(rules, category) in groupedRules" :key="category">
      <h2 class="text-text-neutral-primary font-bold">{{ category }}:</h2>
      <div v-for="(group, title) in rules" :key="`${category}-${title}`">
        {{ title }}:
        <div
          v-for="(rule, index) in group"
          :key="`${index}-${rule.category}-${rule.title}`"
          :class="{ 'font-bold': rule.level === 'critical' }"
        >
          - {{ rule.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { exchangeReturnPolicyEntity } from 'shared';
  import type { Airflow } from '@aviata/platform-types';

  type MiniRule = Airflow.FareRules.MiniRule;

  const props = defineProps<{
    miniRules: Array<MiniRule>;
  }>();

  const groupedRules = computed(() =>
    exchangeReturnPolicyEntity.lib.groupMiniRules(props.miniRules),
  );
</script>
